import { Injectable } from '@angular/core';
import { EndpointOptions, EndpointService } from '../endpoint.service';
import { BaseDao } from '../dao.module';
import { Party } from '../model/party';
import { Observable } from 'rxjs';
import { from } from 'rxjs/observable/from';
import { switchMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ShopsDaoService extends BaseDao<any> {
  constructor(
    endpoint: EndpointService,
    private auth: AuthService,
    private http: HttpClient
  ) {
    super(endpoint);
    this.configure("/shops/", true);
  }
  private url_base = "/s/shops/";

  getShops(): Observable<any> {
    return from(this.auth.firebaseUser.getIdToken()).pipe(
      switchMap((token) => {
        const options = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        };
        return this.http.get<any>(this.url_base, options);
      })
    );
  }

  protected options(): EndpointOptions {
    return {
      secure: true,
      mapper: (shop) => {
        // Check if lab is an array
        if (Array.isArray(shop.result)) {
          return shop.result.map((entry) => {
            const row = {
              entity: 'shop',
              key: entry.id,
              data: entry
            }
            return Party.fromRaw(row)
          });
        } else {
          console.log("SHOP", shop)
          const row = {
            entity: 'shop',
            key: shop.result.id,
            data: shop.result
          }
          return Party.fromRaw(row);
        }
      },
      resource: false,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/dao-service/shops-dao.service.ts